var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "header" }, [
    _c("div", { staticClass: "navigation-bar" }, [
      _c("div", { staticClass: "n_left" }, [
        _c(
          "a",
          {
            staticClass: "logo",
            attrs: { title: "Logo" },
            on: {
              click: function($event) {
                return _vm.$router.push("/newprofile/projects")
              }
            }
          },
          [
            _c(
              "svg",
              {
                attrs: {
                  xmlns: "http://www.w3.org/2000/svg",
                  width: "262.46",
                  height: "64.263",
                  viewBox: "0 0 262.46 64.263"
                }
              },
              [
                _c(
                  "g",
                  {
                    attrs: {
                      id: "Group_77",
                      "data-name": "Group 77",
                      transform: "translate(-461.499 -572.89)"
                    }
                  },
                  [
                    _c(
                      "g",
                      { attrs: { id: "Group_76", "data-name": "Group 76" } },
                      [
                        _c(
                          "g",
                          {
                            attrs: { id: "Group_74", "data-name": "Group 74" }
                          },
                          [
                            _c("path", {
                              attrs: {
                                id: "Path_142",
                                "data-name": "Path 142",
                                d:
                                  "M698.585,613.555a23.353,23.353,0,1,1-11.546-20.549,1.208,1.208,0,0,1,.669,1.71c-1.313,4.286.784,9.912,6.691,10.4a6.535,6.535,0,0,0,.777.041c2.055-.082,2.035-.079,2.595,1.982A24.6,24.6,0,0,1,698.585,613.555Zm-13.809-.176a9.959,9.959,0,0,0-9.889-10.217c-5.7.1-9.769,4.518-9.733,10.463a9.979,9.979,0,0,0,9.886,10.082C680.535,623.681,684.8,619.152,684.776,613.379Z",
                                fill: "#fff"
                              }
                            })
                          ]
                        ),
                        _vm._v(" "),
                        _c("path", {
                          attrs: {
                            id: "Path_143",
                            "data-name": "Path 143",
                            d:
                              "M652.987,628.518a26.478,26.478,0,0,1-.081-30.012c.6-.884.451-1.351-.248-2.014a22.866,22.866,0,0,0-16.6-6.642,24.369,24.369,0,0,0-3.039.229,22.651,22.651,0,0,0-12.07,5.241,32.325,32.325,0,0,1,3.3,14.5c0,7.5-2.356,14.235-6.1,18.893a23.155,23.155,0,0,0,16.44,8.328,23.547,23.547,0,0,0,18.267-6.83C653.466,629.61,653.486,629.244,652.987,628.518Zm-16.849-4.8a10.294,10.294,0,1,1,9.8-10.3A10.093,10.093,0,0,1,636.138,623.717Z",
                            fill: "#fff"
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "g",
                          {
                            attrs: { id: "Group_75", "data-name": "Group 75" }
                          },
                          [
                            _c("path", {
                              attrs: {
                                id: "Path_144",
                                "data-name": "Path 144",
                                d:
                                  "M470.215,587.992h12.327l-8.716,47.072H461.5Z",
                                fill: "#fff"
                              }
                            }),
                            _vm._v(" "),
                            _c("path", {
                              attrs: {
                                id: "Path_145",
                                "data-name": "Path 145",
                                d:
                                  "M526.557,620.135c0,10.222-8.777,14.929-19.983,14.929H482.605l8.716-47.072h22.038c9.837,0,15.129,3.967,15.129,11.028,0,5.649-3.051,9.617-7.783,11.768A9.745,9.745,0,0,1,526.557,620.135Zm-12.264-.268c0-2.825-2.117-3.968-5.105-3.968H498.293l-1.743,9.549h10.708C511.554,625.448,514.293,623.632,514.293,619.867Zm-12.576-22.259-1.681,9.078h8.841c4.358,0,6.723-1.882,6.723-5.38,0-2.555-1.93-3.7-5.167-3.7Z",
                                fill: "#fff"
                              }
                            }),
                            _vm._v(" "),
                            _c("path", {
                              attrs: {
                                id: "Path_146",
                                "data-name": "Path 146",
                                d:
                                  "M549.408,598.281l-1.432,7.935h19.362l-1.8,9.952H546.109l-1.557,8.607H567.4l-1.992,10.289H530.482l8.716-47.072h34.116l-1.93,10.289Z",
                                fill: "#fff"
                              }
                            }),
                            _vm._v(" "),
                            _c("path", {
                              attrs: {
                                id: "Path_147",
                                "data-name": "Path 147",
                                d:
                                  "M606,610.519H616.9l-3.674,19.838a27.265,27.265,0,0,1-17.182,5.648c-13.323,0-21.914-8.406-21.914-20.711,0-16.341,11.144-28.243,27.7-28.243,8.716,0,15.067,3.025,18.989,8.674l-8.841,7.532c-2.863-3.833-6.225-5.178-10.708-5.178-8.965,0-14.692,6.926-14.692,16.34,0,6.322,3.984,10.558,11.144,10.558a14.386,14.386,0,0,0,5.79-1.143Z",
                                fill: "#fff"
                              }
                            })
                          ]
                        ),
                        _vm._v(" "),
                        _c("path", {
                          attrs: {
                            id: "Path_148",
                            "data-name": "Path 148",
                            d:
                              "M471.147,578.817a5.965,5.965,0,0,1,5.906-5.927,6.063,6.063,0,0,1,5.985,5.889,5.991,5.991,0,0,1-5.846,5.994A5.871,5.871,0,0,1,471.147,578.817Z",
                            fill: "#5cc3b9"
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        id: "Path_149",
                        "data-name": "Path 149",
                        d:
                          "M683.512,576.6a15.071,15.071,0,0,1,6.538,3.759A15.94,15.94,0,0,1,695.3,592.7a14.224,14.224,0,0,0,.844,5.918,10.229,10.229,0,0,0,10.272,6.2c4.621-.478,6.151-1.121,10.422-4.17-.547,1.453-.982,2.961-1.661,4.349a16.682,16.682,0,0,1-31.715-7.3c-.028-6.745-.021-13.49-.022-20.235C683.444,577.215,683.483,576.962,683.512,576.6Z",
                        fill: "#101c2b"
                      }
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        id: "Path_150",
                        "data-name": "Path 150",
                        d:
                          "M685.372,578.7a13.388,13.388,0,0,1,5.807,3.339,14.154,14.154,0,0,1,4.666,10.967,12.64,12.64,0,0,0,.75,5.256,9.082,9.082,0,0,0,9.123,5.5c4.1-.424,5.463-.995,9.256-3.7-.486,1.291-.872,2.63-1.475,3.863a14.817,14.817,0,0,1-28.168-6.479c-.025-5.991-.018-11.981-.019-17.972C685.312,579.248,685.346,579.023,685.372,578.7Z",
                        fill: "#5cc3b9"
                      }
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        id: "Path_151",
                        "data-name": "Path 151",
                        d:
                          "M700.309,598.664c-.646-5.61.554-10.683,4.3-15.02a18.548,18.548,0,0,1,14.391-6.626c1.423-.019,2.846-.042,4.268-.011.242.005.691.285.686.424a29.378,29.378,0,0,1-.377,5.6c-.62,2.638-3.386,4.426-6.091,4.556-7.6.366-13.242,3.865-16.786,10.649a4.709,4.709,0,0,1-.257.411C700.437,598.663,700.391,598.655,700.309,598.664Z",
                        fill: "#5cc3b9"
                      }
                    })
                  ]
                )
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "last-saved-info" }, [
          _c("ol", { staticClass: "breadcrumb mb-0" }, [
            _c(
              "li",
              {
                staticClass: "breadcrumb-item",
                attrs: { "aria-current": "page" }
              },
              [
                _c("router-link", { attrs: { to: "/newprofile/projects" } }, [
                  _vm._v("Projects Gallery")
                ])
              ],
              1
            ),
            _vm._v(" "),
            this.selectedStoryTitle
              ? _c(
                  "li",
                  {
                    staticClass: "breadcrumb-item",
                    attrs: { "aria-current": "page" }
                  },
                  [
                    _c(
                      "a",
                      {
                        staticClass: "text-primary",
                        on: { click: _vm.viewStoryDetail }
                      },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(this.selectedStoryTitle) +
                            " Dashboard\n            "
                        )
                      ]
                    )
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "li",
              {
                staticClass: "breadcrumb-item",
                attrs: { "aria-current": "page" }
              },
              [_vm._v("Decision Tree")]
            )
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-73ef935e", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73ef935e","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/v2/main-story-view/header.vue
// module id = null
// module chunks = 